import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import Mission from './components/Mission';
import HowItWorks from './components/HowItWorks';
import Impact from './components/Impact';
import Projects from './components/Projects';
import Contact from './components/Contact';
import Footer from './components/Footer';
import DonationSuccess from './components/DonationSuccess';
import Impressum from './components/Impressum';
import AdminPanel from './components/AdminPanel';
import { Toaster } from './components/ui/sonner';

const HomePage = () => (
  <>
    <Header />
    <Hero />
    <Mission />
    <HowItWorks />
    <Impact />
    <Projects />
    <Contact />
    <Footer />
  </>
);

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/donation-success" element={<DonationSuccess />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/admin" element={<AdminPanel />} />
        </Routes>
        <Toaster />
      </div>
    </BrowserRouter>
  );
}

export default App;
